import { deviceKey } from "@/lib/labels";

const KEY = "deviceFlags";

export function loadFlags() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}

export function persistFlags(map) {
  localStorage.setItem(KEY, JSON.stringify(map));
}

export function isFlagged(d, flags) {
  return !!(flags && flags[deviceKey(d)]);
}

export { deviceKey };
